import React, { useState, useEffect } from 'react';
import AtomicButton from '../../../atomic/button/AtomicButton';
import Loader from '../../../composed/Loader/Loader';
import { Chip, CircularProgress } from "@mui/material";
import FaceIcon from '@mui/icons-material/Face';
import { HomeChefSkeleton } from '../StoreListSkeleton/Skeletons';
import fallBackImage from '../../../global/assets/png/clock-blue.png';
import { MealOfferingCalculation } from './../../../global/calculations';
import { STORE_CLOSED_SHORT_TIME, STORE_NOT_FOUND_404, PRODUCT_NOT_FOUND_404 } from "../../../global/assets/Icons"



const HomeChefs = (props) => {
    const { filteredHomeChefList, handleClickRedirect, customerInfoData } = props
    const tempList = filteredHomeChefList.slice(0, 3)
    const [showLoadMoreButton, setShowLoadMoreButton] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [imageLoaded, setImageLoaded] = useState([])
    const [imageError, setImageError] = useState([])
    const [load, setLoad] = useState(false);
    const { loading, data, success, errorMessage } = customerInfoData
    const custInfoData = data?.data || [];
    const custMealPlan = custInfoData?.meal_Package?.meal_plan;


    useEffect(() => {
        setImageLoaded([]);
        setImageError([]);
        setLoad(true);
    }, [JSON.stringify(filteredHomeChefList)]);

    useEffect(() => {
        if (load) {
            setLoad(false);
        }
    }, [load]);


    const onLoadMore = () => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
            setShowLoadMoreButton(false)
        }, 3000)

    }

    const onImageLoad = (index) => {
        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })

    }

    const onImageError = (index) => {
        setImageError((prev) => {
            prev[index] = true;
            return [...prev];
        })

        setImageLoaded((prev) => {
            prev[index] = true;
            return [...prev];
        })
    }

    console.log('----HomeChef desktop', filteredHomeChefList)

    return (
        <div style={{ width: '702px', height: 'auto', marginTop: '10px', position: 'relative', }}>
            <div style={{ marginTop: '15px', marginBottom: '2px', marginLeft: '10px', fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '16px', color: '#168039' }}> Home Chefs </div>
            <div style={{ margin: '0px 0px 10px 10px', fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 500, fontSize: '12px', color: '#45BF55' }}> Local home chef serving home made food with affordable price</div>
            {isLoading && <div style={{ display: 'flex', flexDirection: 'row' }}>{[1, 2, 3].map((n) => <HomeChefSkeleton key={n} />)} </div>}
            {!isLoading && <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                {!load && ((showLoadMoreButton ? tempList : filteredHomeChefList).map((el, index) =>
                    <div style={{
                        cursor: el.storeIsClosedForShortTime ? 'default' : 'pointer',
                        width: '221px',
                        minHeight: '100px',
                        borderRadius: '5px 5px 0px 0px',
                        border: '1px solid #DBD6D6',
                        margin: '10px 5px 0px 5px'
                    }}
                        key={el.kitchenName} onClick={el.storeIsClosedForShortTime ? null : (e) => handleClickRedirect(e, el)}>
                        <div style={{
                            height: el.display_image === null ? '160px' : null,
                            borderRadius: '5px 5px 0px 0px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            objectFit: 'cover',
                            // border: '1px solid red'
                        }}>       <img
                                width={imageLoaded[index] ? '100%' : 0}
                                src={imageError[index] ? fallBackImage : el.display_image}
                                onLoad={() => onImageLoad(index)}
                                onError={() => onImageError(index)}
                                key={el._id}
                            />
                            {!imageLoaded[index] &&
                                <Loader color='black' width='20px' height='20px' />}

                        </div>
                        <div style={{
                            height: 'auto',
                            // borderRadius: '5px 5px 0px 0px',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            flexWrap: 'wrap',
                            // alignItems: 'center',
                            // justifyContent: 'center',
                            borderTop: '1px solid #DBD6D6',
                            padding: '5px'
                            // backgroundColor: '#F8F8F8'
                        }}>
                            {el.storeIsClosedForShortTime && <img style={{ width: '50px' }} src={STORE_CLOSED_SHORT_TIME} alt=""></img>}
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', marginTop: '5px', marginLeft: '5px', textTransform: 'capitalize' }}> {el.display_name || el.kitchenName}</div>
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 400, fontSize: '12px', marginLeft: '5px', marginBottom: '10px', textTransform: 'capitalize', color: '#707070' }}> {el.cuisine}</div>
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '12px', marginTop: '2px', marginLeft: '5px', color: 'gray' }}> Cooking pass 10 years Cooking pass 10 years Cooking pass 10 years </div>
                            <div style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 600, fontSize: '10px', marginTop: '15px', marginLeft: '5px', marginBottom: '5px', color: 'black', }}> Combo Items ( Per Person )</div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                margin: '5px 0px 10px 0px'

                            }}>
                                {el.meal_offering.kids_menu !== 0 && <Chip icon={<FaceIcon />} label={`${MealOfferingCalculation({ CustomerMealPackage: custMealPlan, KitchenMealOffering: el.meal_offering.kids_menu })} Kids Menu`} sx={{ width: 'auto', height: '20px', border: '1px solid #ffc57b', background: '#ffeaa6', color: '#181436', fontWeight: 600, fontSize: '10px', borderRadius: '3px', margin: ' 0px 5px 3px 0px' }} />}
                                {el.meal_offering.main_dish !== 0 && <Chip label={`${MealOfferingCalculation({ CustomerMealPackage: custMealPlan, KitchenMealOffering: el.meal_offering.main_dish })} Main dish`} sx={{ color: '#181436', width: 'auto', height: '20px', fontWeight: 600, fontSize: '10px', marginRight: '5px', borderRadius: '3px', }} />}
                                {el.meal_offering.side !== 0 && <Chip label={`${MealOfferingCalculation({ CustomerMealPackage: custMealPlan, KitchenMealOffering: el.meal_offering.side })} Sides`} size='small' sx={{ color: '#181436', width: 'auto', height: '20px', fontWeight: 600, fontSize: '10px', marginRight: '5px', borderRadius: '3px', }} />}
                                {el.meal_offering.complementry !== 0 && <Chip label={`${MealOfferingCalculation({ CustomerMealPackage: custMealPlan, KitchenMealOffering: el.meal_offering.complementry })} Complementry`} sx={{ border: '1px solid #86c49a', background: '#dff5cf', color: '#06763f', width: 'auto', height: '20px', fontWeight: 600, fontSize: '10px', marginRight: '5px', borderRadius: '3px', }} />}

                            </div>
                        </div>
                        <div style={{
                            height: '30px',
                            borderRadius: '5px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            objectFit: 'cover',
                            backgroundColor: '#F8F8F8',
                            // border: '1px solid red',
                            fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 300, fontSize: '10px'
                        }}> Spend $30 Get $10 off <span style={{ fontSize: '10px', }}> Exp.10/10/2023</span> </div>
                    </div>))}

            </div>
            }
            {showLoadMoreButton && filteredHomeChefList.length > 3 && <AtomicButton
                label="Load more ..."
                handleSubmit={onLoadMore}
                style={{ width: "200px", height: "25px", marginLeft: '35%', backgroundColor: '#f4f5f6', color: 'grey', }}
                loading={false}
            />}
        </div>

    )
}

export default HomeChefs